import "./FloatingIconsRendererComponent.scss";
import {
    User, Pencil, Package, Users, BarChart, Settings, FileText, HelpCircle
} from "lucide-react";
import {motion} from "framer-motion";



const ICONS = [
    {icon: <User size={24} strokeWidth={1}/>, left: "20%", top: "30%"},
    {icon: <Package size={24} strokeWidth={1}/>, left: "10%", top: "45%"},
    {icon: <Pencil size={24} strokeWidth={1}/>, left: "23%", bottom: "43%"},
    {icon: <BarChart size={24} strokeWidth={1}/>, left: "12%", bottom: "30%"},
    {icon: <Users size={24} strokeWidth={1}/>, right: "20%", top: "30%"},
    {icon: <Settings size={24} strokeWidth={1}/>, right: "10%", top: "45%"},
    {icon: <FileText size={24} strokeWidth={1}/>, right: "23%", bottom: "43%"},
    {icon: <HelpCircle size={24} strokeWidth={1}/>, right: "12%", bottom: "30%"}
];

const FloatingIconsRendererComponent = () => {

    return (
        <>
            {ICONS.map(({icon, ...style}, index) => (
                <motion.div
                    key={index}
                    initial={{opacity: 0, scale: 0.5}}
                    animate={{opacity: 1, scale: 1}}
                    transition={{duration: 0.2, delay: 1.5 + index * 0.05}}
                    className="absolute text-[#183c2c] icon-hover"
                    style={{position: "absolute", ...style}}
                >
                    {icon}
                </motion.div>
            ))}
        </>
    );

};

export default FloatingIconsRendererComponent;
